import PropTypes from "prop-types";
import { EnvironmentFilled } from "@ant-design/icons";
import { Spin } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RowActionsMenu } from "../../../components/data-table";

function formatLocationSubtitle(location) {
    const city = location?.city?.trim();
    const state = location?.state?.trim();
    const country = location?.country?.trim();

    const cityState = [city, state].filter(Boolean).join(", ");
    if (cityState && country) {
        return `${cityState} • ${country}`;
    }
    return cityState || country || "";
}

function LocationCard({ location, t, actionItems, onActionClick, menuDisabled, isActionLoading }) {
    const carCount = location?.cars?.length ?? 0;
    const subtitle = formatLocationSubtitle(location);

    return (
        <article className="relative overflow-hidden rounded-2xl border border-[#E5E7EB]/80 bg-white shadow-sm ring-1 ring-black/[0.03]">
            {isActionLoading ? (
                <div
                    className="absolute inset-0 z-10 flex items-center justify-center rounded-2xl bg-white/70"
                    aria-busy="true"
                    aria-live="polite">
                    <Spin />
                </div>
            ) : null}
            <div
                className={`flex items-start gap-3 p-4${isActionLoading ? " pointer-events-none select-none opacity-50" : ""}`}
                aria-hidden={isActionLoading}>
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#EEF2FF]">
                    <EnvironmentFilled className="text-xl text-[#5D5DF6]" />
                </div>

                <div className="flex min-w-0 flex-1 flex-col gap-1 pr-1">
                    <p className="m-0 text-base font-semibold leading-snug text-[#2F2F46]">
                        {location?.address || t("notAvailable")}
                    </p>
                    {subtitle ? (
                        <p className="m-0 text-sm leading-snug text-[#667085]">{subtitle}</p>
                    ) : null}
                    <p className="m-0 mt-1 text-xs font-bold uppercase tracking-wide text-[#22C55E]">
                        {t("mobileList.locationCarsCount", { count: carCount })}
                    </p>
                </div>

                <RowActionsMenu
                    items={actionItems}
                    onClick={({ key }) => onActionClick(key, location)}
                    label={t("action")}
                    disabled={menuDisabled}
                    icon={<BsThreeDotsVertical className="text-xl" />}
                    className="!h-8 !w-8 shrink-0 !rounded-full text-[#667085]"
                />
            </div>
        </article>
    );
}

LocationCard.propTypes = {
    location: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    actionItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    onActionClick: PropTypes.func.isRequired,
    menuDisabled: PropTypes.bool,
    isActionLoading: PropTypes.bool,
};

export default LocationCard;
